import { render, staticRenderFns } from "./SIM.vue?vue&type=template&id=264ad7b8&"
import script from "./SIM.vue?vue&type=script&lang=ts&"
export * from "./SIM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports